import { SET_PROMOTION, RESET_PROMOTION } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.promotion, action) {
  switch (action.type) {
    case SET_PROMOTION:
      return action.payload;
    case RESET_PROMOTION:
      return initialState.promotion;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/promotions/reducer.js